import React from 'react';
import AdminIcon from 'src/components/10-atoms/icons/AdminIcon';
import { RootTab } from 'src/navigation/TabNavigation';
import withSuspense from 'src/navigation/withSuspense';
const Home = withSuspense(React.lazy(() => import('./screens/Home')));
export const renderAdminTabRoutes = ({ translate }) => {
    return (React.createElement(RootTab.Group, null,
        React.createElement(RootTab.Screen, { name: "Admin_Home", options: {
                tabBarLabel: translate('Admin'),
                tabBarIcon: props => React.createElement(AdminIcon, { ...props }),
            }, component: Home })));
};
